import type { GridNaming } from './projection';

const MASC = ['Первый', 'Второй', 'Третий', 'Четвёртый', 'Пятый', 'Шестой', 'Седьмой', 'Восьмой', 'Девятый', 'Десятый', 'Одиннадцатый', 'Двенадцатый', 'Тринадцатый', 'Четырнадцатый', 'Пятнадцатый'];
const FEM = ['Первая', 'Вторая', 'Третья', 'Четвёртая', 'Пятая', 'Шестая', 'Седьмая', 'Восьмая', 'Девятая', 'Десятая', 'Одиннадцатая', 'Двенадцатая', 'Тринадцатая', 'Четырнадцатая', 'Пятнадцатая'];

/** "Первый ряд" / "Первая полка" for n>=1; numeric fallback past the table. */
export function ordinalName(n: number, naming: GridNaming): string {
  if (naming === 'ряд') {
    const w = MASC[n - 1] ?? `${n}-й`;
    return `${w} ряд`;
  }
  const w = FEM[n - 1] ?? `${n}-я`;
  return `${w} полка`;
}
